import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgSgx({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.992 10.002h2.397v6.308l.006.296c0 .42-.089.819-.267 1.198-.178.38-.415.687-.71.922-.296.234-.672.404-1.127.51a7 7 0 01-1.563.156c-1.342 0-3.542-.626-3.51-2.041h2.668c.183.453.538.438.823.438.37 0 .645-.1.827-.296.183-.197.274-.541.274-1.032v-.52c-.252.297-.87.683-2.023.665-.894 0-1.848-.366-2.397-1.146-.39-.553-.497-1.505-.497-2.415 0-1.04.388-1.831.892-2.377.503-.545 1.161-.817 1.975-.817.52 0 .948.088 1.286.264.337.176.653.467.947.874v-.987zm-2.409 3.239c0 .482.103.84.309 1.072.205.233.476.35.811.35.319 0 .586-.121.802-.362.216-.241.324-.605.324-1.091 0-.487-.113-.859-.34-1.117a1.064 1.064 0 00-.83-.387.962.962 0 00-.783.356c-.195.237-.292.63-.292 1.179z"
        fill="#999"
      />
      <path
        d="M21.907 7.755h-3.061l-.887 1.755-.922-1.755H14.01l2.385 3.324-2.367 3.569h3.008l.912-1.94.897 1.94h3.061l-2.318-3.569 2.318-3.324z"
        fill="#3B4B7E"
      />
      <path
        d="M14.465 13.937l1.873-2.857-2.332-3.327h1.125l1.116.909.673 1.371v1.013c0 .094-.315.6-.943 1.52-.48.776-.763 1.134-.846 1.072-.07-.052-.293.048-.666.299z"
        fill="#999"
      />
      <path
        d="M14.747 7.752h.755s.843.465 1.338.92c.494.456 1.655 1.85.402 3.382-1.253 1.531-3.053 2.231-3.176 2.3 1.181-1.695 2.534-2.441 2.534-3.987 0-1.545-1.853-2.615-1.853-2.615z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 11.384h2.867c.192.438.194.498.38.723.185.225.518.354 1.063.354.406 0 .717-.11.937-.302.22-.19.37-.374.37-.625 0-.212-.16-.386-.251-.463-.252-.202-.696-.367-1.46-.535-1.249-.28-2.266-.545-2.798-1.01-.537-.466-.894-1.166-.894-1.887 0-.474.075-1.085.35-1.506.274-.422.811-.961 1.363-1.203.551-.24 1.422-.43 2.383-.43 1.422 0 2.239.454 2.857.892.619.438 1.02 1.112 1.138 2.068H7.399c-.033-.332-.261-.582-.316-.664-.056-.082-.304-.325-.916-.325-.491 0-.683.09-.896.28-.212.191-.207.427-.207.628 0 .147.069.279.207.396.135.122.453.235.956.34 1.246.268 2.181.526 2.72.801.539.275.941.565 1.187.972.245.407.41.927.41 1.43 0 .591-.174 1.15-.501 1.65-.327.499-.87.86-1.457 1.119-.587.258-1.327.387-2.22.387-1.569 0-2.655-.302-3.258-.906-.604-.604-1.028-1.253-1.108-2.184z"
        fill="#3B4B7E"
      />
    </svg>
  )
}

export default SvgSgx
